export default "__VITE_ASSET__DC2ARplb__"